/** Наборы символик для камеры-сканера.
 *
 * ⚠️ Лежат ОТДЕЛЬНО от `CameraScanner`, а не рядом с ним, ровно по одной
 * причине: экраны импортируют их статически, а сам сканер грузится ленивым
 * чанком (`lazyChunk` + `usePreloadChunk`). Импортируй экран константу из
 * модуля камеры — статический импорт утянул бы камеру в основной бандл, и
 * ленивая загрузка исчезла бы молча (проверено: бандл +54 КБ, чанка камеры в
 * сборке не остаётся).
 *
 * ⚠️ Список у каждого экрана СВОЙ, и это не педантизм: `BarcodeDetector`
 * перебирает символики на каждом кадре, и лишние замедляют распознавание там,
 * где важна скорость (скан ЧЗ идёт сотнями за смену).
 *
 * Обратная сторона — символика, которой в списке нет, не «плохо читается», а
 * НЕ ВИДНА ВООБЩЕ: камера молчит, ошибки нет, показать нечего. На этом уже
 * дважды обожглись — вход по пропуску и проверка отгрузки, — поэтому наборы
 * названы здесь, а не собираются по месту в каждом экране.
 */

/** Товарные коды склада: ЧЗ-DataMatrix и EAN13 упаковки. Дефолт: на
 *  большинстве экранов сканируют именно товар. */
export const GOODS_FORMATS = ["data_matrix", "ean_13"];

/** Только QR — наша собственная печать: пропуск, этикетка паллеты. Там больше
 *  ничего не сканируют, и сужение списка ускоряет распознавание. */
export const QR_FORMATS = ["qr_code"];

/** QR + товарные коды: экраны, где рядом лежат наши наклейки и товар. В
 *  проверке перемещений сканируют и QR-этикетки, наклеенные на приёмке, и
 *  EAN13/DataMatrix на самой упаковке. */
export const GOODS_AND_QR_FORMATS = ["qr_code", "data_matrix", "ean_13"];

/** Линейные (1D) символики: код широкий и низкий, читается только целиком по
 *  ширине. Список перечисляет то, что вообще может встретиться в наборах выше;
 *  двумерные (`data_matrix`, `qr_code`) сюда не входят. */
const LINEAR_FORMATS = new Set([
  "ean_13",
  "ean_8",
  "upc_a",
  "upc_e",
  "code_128",
  "code_39",
  "code_93",
  "itf",
  "codabar",
]);

/** Есть ли в наборе экрана линейная символика.
 *
 *  Нужно камере: для 1D-кода она пробует дополнительный вырез кадра ПОЛОСОЙ во
 *  всю ширину (`scan-ui/crop-regions.ts`) и рисует широкую рамку прицела. На
 *  чисто QR/DataMatrix-экранах лишний проход по кадру не делаем — там важна
 *  скорость скана ЧЗ. */
export function hasLinearFormat(formats: readonly string[]): boolean {
  return formats.some((f) => LINEAR_FORMATS.has(f));
}
